module.exports = __webpack_public_path__ + "images/emoji/steam_locomotive.02ca8d583a6e216cf507.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/steam_locomotive.png
// module id = mz0K
// module chunks = 24